import { Shield, Clock, DollarSign } from 'lucide-react';

const pillars = [
  {
    icon: Shield,
    title: '25-Year Warranty',
    description: 'Every cable run backed by our industry-leading warranty. Install once, trust forever.',
    accent: 'text-cobalt-400',
    bg: 'bg-cobalt-500/10',
  },
  {
    icon: Clock,
    title: '15-Minute Response',
    description: 'Guaranteed response time, 24/7. Local Treasure Valley technicians, not a call center.',
    accent: 'text-emerald-400',
    bg: 'bg-emerald-500/10',
  },
  {
    icon: DollarSign,
    title: 'Zero Hidden Fees',
    description: 'Transparent pricing from day one. Month-to-month contracts, cancel anytime.',
    accent: 'text-yellow-400',
    bg: 'bg-yellow-500/10',
  },
];

export function ValuePillars() {
  return (
    <section className="py-16 bg-navy-950 border-t border-white/5">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {pillars.map((pillar) => {
            const Icon = pillar.icon;
            return (
              <div
                key={pillar.title}
                className="text-center p-8 rounded-2xl border border-white/10 bg-white/5"
              >
                <div className={`inline-flex p-4 rounded-xl ${pillar.bg} mb-4`}>
                  <Icon className={`w-8 h-8 ${pillar.accent}`} />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{pillar.title}</h3>
                <p className="text-gray-300 text-sm leading-relaxed">{pillar.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
